module.exports = __webpack_public_path__ + "img/NewLogo-White.14957afa.png";